module.exports = __webpack_public_path__ + "img/0.13a53f96.svg";